module.exports = __webpack_public_path__ + "media/images/image-placeholder-0-7d62c49c92067321d8f2004ed1b05fea.jpg";